<div>
	@if (!this.showTransferDeviceOwnershipConfirmation) {
		<p class="dialog-content-container-margin dialog-content-container-header">
			<b i18n="@@transferDeviceOwnershipDialog-dialogTitle-Edit">Edit</b> |
			<ng-container i18n="@@transferDeviceOwnershipDialog-dialogTitle-DeviceOwner">Device Owner</ng-container>
		</p>
	}

	@if (!this.showTransferDeviceOwnershipConfirmation) {
		<mat-divider class="dialog-content-container-margin"></mat-divider>
	}

	@if (this.showTransferDeviceOwnershipViewDisabled) {
		<div>
			<mat-dialog-content
				class="dialog-content-container-margin dialog-content-container-width"
				i18n="@@transferDeviceOwnershipDialog-dialogContent"
			>
				Transfer device ownership of [{{ this.selectedDevices.length }}] devices to the following company:
			</mat-dialog-content>
			<div class="content-container-body column spacing-24 dialog-content-container-margin">
				<div class="row">
					<mat-form-field subscriptSizing="dynamic" class="column-double" appearance="outline">
						<mat-label i18n="@@transferDeviceOwnershipDialog-searchForCompany">Search for company</mat-label>
						<input
							matInput
							#filterInput
							[matAutocomplete]="auto"
							data-automation-id="search-company-input"
							(keyup)="companySearchEvents.next(filterInput.value)"
						/>
						<mat-icon matPrefix>search</mat-icon>
						<mat-autocomplete
							#auto="matAutocomplete"
							[displayWith]="displayCompanyName"
							data-automation-id="search-company-picker"
						>
							@for (item of companySearchResults | async; track item.id ?? item) {
								<mat-option
									[value]="item"
									(click)="onCompanySelected(item)"
									[attr.data-automation-id]="'company-search-result-' + displayCompanySearchItem(item)"
								>
									{{ displayCompanySearchItem(item) }}
								</mat-option>
							}
						</mat-autocomplete>
					</mat-form-field>
				</div>
				<mat-dialog-actions class="dialog-content-container-button-position-right">
					<button
						mat-button
						class="secondary-button dialog-content-container-button-small"
						i18n="@@transferDeviceOwnershipDialog-searchCompanyButtonCancel"
						data-automation-id="transfer-ownership-cancel-button"
						(click)="onCancelClicked()"
					>
						Cancel
					</button>
					<button
						mat-button
						class="primary-button dialog-content-container-button-small"
						i18n="@@transferDeviceOwnershipDialog-searchCompanyButtonNext"
						[disabled]="this.nextButtonDisabled"
						data-automation-id="transfer-ownership-next-button"
						(click)="onNextClicked()"
					>
						Next
					</button>
				</mat-dialog-actions>
			</div>
		</div>
	} @else {
		@if (!this.showTransferDeviceOwnershipConfirmation) {
			<div>
				<mat-dialog-content
					class="dialog-content-container-margin dialog-content-container-width"
					i18n="@@transferDeviceOwnershipDialog-dialogContentConfirm"
				>
					Ownership of [{{ this.selectedDevices.length }}] devices will be transferred between the companies below. This
					action cannot be undone. Proceed?
				</mat-dialog-content>
				<div class="content-container-body column spacing-24 dialog-content-container-margin">
					<div class="row spacing-24">
						<div class="column" style="max-width: 120px">
							<p class="content-sub-title">Transfer From</p>
							<p class="content-sub-body">{{ this.originalCompany.name }}</p>
						</div>
						<mat-icon class="content-sub-icon">arrow_forward_ios</mat-icon>
						<div class="column">
							<p class="content-sub-title">Transfer To</p>
							<p class="content-sub-body">{{ this.company.name }}</p>
						</div>
					</div>
					<mat-dialog-actions class="dialog-content-container-button-position-right">
						<button
							mat-button
							class="secondary-button dialog-content-container-button-small"
							i18n="@@transferDeviceOwnershipDialog-buttonCancel"
							data-automation-id="transfer-ownership-cancel-two-button"
							(click)="onCancelClicked()"
						>
							Cancel
						</button>
						<button
							mat-button
							class="primary-button dialog-content-container-button-small"
							i18n="@@transferDeviceOwnershipDialog-buttonTransferOwnership"
							data-automation-id="transfer-ownership-button"
							(click)="onTransferDeviceOwnershipClicked()"
						>
							Transfer Ownership
						</button>
					</mat-dialog-actions>
				</div>
			</div>
		} @else {
			@if (this.showTransferDeviceOwnershipConfirmationSuccess) {
				<div class="column" style="align-items: center">
					<mat-icon class="success-checkmark">check</mat-icon>
					<p>[{{ this.selectedDevices.length }}] device(s) successfully transferred!</p>
					<mat-dialog-actions class="content-actions">
						<button
							mat-button
							class="primary-button dialog-content-container-button-small"
							i18n="@@transferDeviceOwnershipDialog-buttonConfirm"
							data-automation-id="transfer-ownership-confirm-button"
							(click)="onConfirmClicked()"
						>
							Confirm
						</button>
					</mat-dialog-actions>
				</div>
			} @else {
				<div class="column" style="align-items: center">
					<mat-icon class="failure-crossout">close</mat-icon>
					<p>Devices failed to transfer. Try again?</p>
					<mat-dialog-actions class="content-actions">
						<button
							mat-button
							class="secondary-button dialog-content-container-button-small"
							i18n="@@transferDeviceOwnershipDialog-buttonCancel"
							data-automation-id="transfer-ownership-cancel-three-button"
							(click)="onCancelClicked()"
						>
							Cancel
						</button>
						<button
							mat-button
							class="primary-button dialog-content-container-button-small"
							i18n="@@transferDeviceOwnershipDialog-buttonRetry"
							data-automation-id="transfer-ownership-retry-button"
							(click)="onRetryClicked()"
						>
							Retry
						</button>
					</mat-dialog-actions>
				</div>
			}
		}
	}
</div>
